import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import K from "utilities/constants";
import { redirectToLogin, redirectToUrl } from "utilities/generalUtility";
import { saveUserData } from "redux/user/userSlice";
import { message } from "antd";

export default class User {
  // API call using thunk.
  static loginCall(roleType, email, password, remember) {
    return async (dispatch) => {
      const user = await NetworkCall.fetch(
        Request.loginUser(roleType, email, password)
      );

      message.success(user?.message);
      let encryptedUser = CryptoJS.AES.encrypt(
        JSON.stringify(user),
        K.Cookie.Key.EncryptionKey
      );
      Cookies.set(K.Cookie.Key.User, encryptedUser, {
        path: "/",
        domain: K.Network.URL.Client.BaseHost,
        expires: remember ? 365 : "",
      });

      // here we can store loggedIn user date to redux store
      dispatch(saveUserData(user));

      return user;
    };
  }

  static async getUserProfile() {
    const user = await NetworkCall.fetch(Request.getProfileImage());

    // message.success(user?.message);

    let encryptedUser = CryptoJS.AES.encrypt(
      JSON.stringify(user),
      K.Cookie.Key.EncryptionKey
    );
    Cookies.set(K.Cookie.Key.User, encryptedUser, {
      path: "/",
      domain: K.Network.URL.Client.BaseHost,
      expires: true ? 365 : "",
    });
    window.location.reload();
    return user;
  }

  //login with google

  static loginWithGoogle(data) {
    return async (dispatch) => {
      const user = await NetworkCall.fetch(
        Request.loginWithGoogle(data),
        false
      );

      message.success(user?.message);

      let encryptedUser = CryptoJS.AES.encrypt(
        JSON.stringify(user),
        K.Cookie.Key.EncryptionKey
      );
      Cookies.set(K.Cookie.Key.User, encryptedUser, {
        path: "/",
        domain: K.Network.URL.Client.BaseHost,
        expires: true ? 365 : "",
      });

      // here we can store loggedIn user date to redux store
      dispatch(saveUserData(user));

      return user;
    };
  }
  static Register(values) {
    return async () => {
      const registeredUser = await NetworkCall.fetch(Request.register(values));
      registeredUser && message.success(registeredUser?.message);
      return registeredUser;
    };
  }
  static logoutCall(error = "") {
    Cookies.remove(K.Cookie.Key.User, {
      path: "/",
      domain: K.Network.URL.Client.BaseHost,
    });
    redirectToLogin(error);
  }

  //Forgot password
  static async forgotPassword(email) {
    const user = await NetworkCall.fetch(Request.forgotPassword(email));
    user && message.success(user?.message);
    return user;
  }
  static async verifyUser(data, queryParams) {
    try {
      const user = await NetworkCall.fetch(Request.verifyUser(data), false);
      let encryptedUser = CryptoJS.AES.encrypt(
        JSON.stringify(user),
        K.Cookie.Key.EncryptionKey
      );
      Cookies.set(K.Cookie.Key.User, encryptedUser, {
        path: "/",
        domain: K.Network.URL.Client.BaseHost,
        expires: false ? 365 : "",
      });
      user && message.success(user?.message);
      // user &&
      //   redirectToUrl(
      //     "/journal-request",
      //     queryParams.get("diaryId"),
      //     queryParams.get("diaryTopicId")
      //   );
      const res = await NetworkCall.fetch(Request.getSettings());
      const settings = res?.data?.tableListing;
      const index = settings.findIndex((e) => e?.id === 300);

      user &&
        redirectToUrl(
          `${
            settings[index].value === "1" ? "/personality" : "/journal-request"
          }`,
          queryParams.get("diaryId"),
          queryParams.get("diaryTopicId")
        );

      return user;
    } catch (error) {
      error?.error && message.error(error.message);
    }
  }

  //Reset password
  static resetPassword(data) {
    return async (dispatch) => {
      const user = await NetworkCall.fetch(Request.resetPassword(data), true);
      // let encryptedUser = CryptoJS.AES.encrypt(
      //   JSON.stringify(user),
      //   K.Cookie.Key.EncryptionKey
      // );
      // Cookies.set(K.Cookie.Key.User, encryptedUser, {
      //   path: "/",
      //   domain: K.Network.URL.Client.BaseHost,
      //   expires: true ? 365 : "",
      // });
      user && message.success(user?.message);
      return user;
    };
  }

  // Selectors

  // Helpers
  static getUserObjectFromCookies() {
    let cookieUser = Cookies.get(K.Cookie.Key.User);
    let bytes = cookieUser
      ? CryptoJS.AES.decrypt(cookieUser, K.Cookie.Key.EncryptionKey)
      : "{}";
    try {
      let utfBytes = bytes.toString(CryptoJS.enc.Utf8);
      // console.log("cookie data is", JSON.parse(utfBytes));

      return JSON.parse(utfBytes);
    } catch (error) {
      return this.logoutCall("User unauthorized");
    }
  }

  static isTokenAvailable() {
    return this.getUserObjectFromCookies()?.data?.token ? true : false;
  }

  static getToken() {
    return this.getUserObjectFromCookies()?.data?.token ?? "";
  }
  static getCardStatus() {
    return this.getUserObjectFromCookies()?.data?.isSubscriptionConfirmed ?? "";
  }
  static isUserctive() {
    return this.getUserObjectFromCookies()?.data?.user?.isActive ?? "";
  }

  static getName() {
    const firstName = this.getUserObjectFromCookies()?.data?.user?.firstName;
    const lastName = this.getUserObjectFromCookies()?.data?.user?.lastName;

    return firstName + " " + lastName ?? "";
  }

  static getEmail() {
    return this.getUserObjectFromCookies()?.data?.user?.email ?? "";
  }
  static getProfilePicture() {
    return this.getUserObjectFromCookies()?.data?.user?.profileImageUrl ?? "";
  }

  static getPortalUser() {
    return this.getUserObjectFromCookies()?.data?.user?.portalUser ?? "";
  }

  static getUserId() {
    return this.getUserObjectFromCookies()?.data?.user?.id ?? "";
  }
  static roles() {
    return [K.Roles.User];
  }

  //resend verification email
  static async resendVerificationEmail(data) {
    try {
      const user = await NetworkCall.fetch(
        Request.resendVerificationEmail(data),
        false
      );
      // let encryptedUser = CryptoJS.AES.encrypt(
      //   JSON.stringify(user),
      //   K.Cookie.Key.EncryptionKey
      // );
      // Cookies.set(K.Cookie.Key.User, encryptedUser, {
      //   path: "/",
      //   domain: K.Network.URL.Client.BaseHost,
      //   expires: false ? 365 : "",
      // });
      user && message.success(user?.message);
      return user;
    } catch (error) {}
  }
  static async getUserRoles() {
    try {
      const roles = await NetworkCall.fetch(Request.getUserRoles());
      return roles;
    } catch (error) {}
  }
  static async getAllTopics(data) {
    // try {
    const topics = await NetworkCall.fetch(Request.getAllTopics(data), false);
    return topics;
    // } catch (error) {}
  }
  static async addEntry(value) {
    const res = await NetworkCall.fetch(Request.addEntry(value), false);
    return res;
  }
}
